import BaseService from "@/services/BaseService";
import * as URI from "../reports/constant";

const action = {
  async getDirectSchemeListAction({ commit }, payload) {
    let url = URI.REPORT_DIRECT_SCHEME_LIST.replace(
      "{searchTerm}", payload?.searchTerm ? payload?.searchTerm : "");
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async getCriteriaReportAction({ commit }, payload) {
    let url = URI.REPORT_CREITERIA_REPORT_LIST.replace(
      "{searchTerm}", payload?.searchTerm ? payload?.searchTerm : "");
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async getScheduleReportListAction({ commit }, payload) {
    let url = URI.REPORT_SCHEDULE_LIST_URL.replace(
      "{reportFor}",
      payload.reportFor
    )
      .replace("{currentPage}", payload.page.currentPage)
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const scheduleReport = await BaseService.getSchemePlanningClient().get(url);
    commit("setReports", scheduleReport.data);
    return scheduleReport.data;
  },
  async getScheduleReportIMEIListAction({ commit }, payload) {
    let url = URI.REPORT_SCHEDULE_IMEI_LIST_URL.replace(
      "{reportFor}",
      payload.reportFor
    )
      .replace("{currentPage}", payload.page.currentPage)
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const scheduleReport = await BaseService.getSchemePlanningClient().get(url);
    commit("setReports", scheduleReport.data);
    return scheduleReport.data;
  },
  async modifyScheduleReportAction({ commit }, payload) {
    let url = URI.REPORT_SCHEDULE_LIST_MODIFY_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async viewScheduleReportAction({ commit }, payload) {
    let url = URI.REPORT_SCHEDULE_LIST_VIEW_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async downloadReportExcelAction({ commit }, payload) {
    const url = URI.REPORT_EXPORT_FILE_URL.replace("{file}", payload.file);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadReportIMEIExcelAction({ commit }, payload) {
    const url = URI.REPORT_EXPORT_IMEI_FILE_URL.replace("{file}", payload.file);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async getDirectCommunicationListAction({ commit }, payload) {
    let url = URI.REPORT_DIRECT_COMMUNICATION_LIST.replace(
      "{incentiveAudience}",
      payload.incentiveAudience
    )
      .replace("{divisionName}", payload.divisionName)
      .replace("{startDate}", payload.startDate)
      .replace("{endDate}", payload.endDate);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async findReportTemplate({ commit }, payload) {
    let url = URI.REPORT_TEMPLATE_LIST.replace(
      "{division}",
      payload.division
    ).replace("{channel}", payload.channel)
      .replace("{audiance}", payload.audiance);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async findReportAttribute({ commit }, payload) {
    let url = URI.REPORT_ATTRIBUTE_LIST.replace("{channel}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async partialPayoutDateAction({ commit }, payload) {
    const url = URI.PARTIAL_PAYOUT_DATE.replace("{schemeId}", payload)
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async doaReportFilterAction({ commit }, payload) {
    const url = URI.DOA_REPORT_FILTER
      .replace("{audienceId}", payload.audienceId)
      .replace("{divisionId}", payload.divisionId)
      .replace("{channelId}", payload.channelId)
      .replace("{fromDate}", payload.startDate)
      .replace("{toDate}", payload.endDate);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async doaReportScheduleAction({ commit }, payload) {
    let url = URI.DOA_REPORT_SCHEDULE;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async getSchemeProgramDataPayout({ commit }, payload) {
    let url = URI.SCHEME_PROGRAM_PAYOUT_ITEM_GRID_URL.replace("reportIds", payload.rptQueId)
      .replace("{currentPage}", payload.page.currentPage)
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const schemePrgGridItem =
      await BaseService.getSchemePlanningClient().get(url);
    return schemePrgGridItem.data;
  },
  async downloadSchemeProgramExportPayout({ commit }, payload) {
    const url = URI.SCHEME_PROGRAM_PAYOUT_DOWNLOAD_URL.replace("{reportID}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },

  // NERP REPORTS APIs

  async nerpReportStatusListAction({ commit }, payload) {
    let url = URI.NERP_REPORT_STATUS_LIST.replace(
      "{report-type}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async nerpReportAccrualListAction({ commit }, payload) {
    let url = URI.NERP_REPORT_ACCRUAL_LIST.replace(
      "{searchTerm}", payload.searchTerm);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async getAccrualSchemeListAction({ commit }, payload) {
    let url = "";
    if (payload.isBulkSelected) {
      url = URI.REPORT_ACCRUAL_BULK_SCHEME_LIST.replace(
        "{isBulkSelected}", payload.isBulkSelected).replace(
          "{accrual}", payload.accrualNo.toString())
        .replace("{currentPage}", payload.page.currentPage)
        .replace("{pageSize}", payload.page.pageSize)
        .replace("{value}", payload.sord.value)
        .replace("{sortOrder}", payload.sord.__sortOrder);
    }
    else {
      url = URI.REPORT_ACCRUAL_SCHEME_LIST.replace(
        "{isBulkSelected}", payload.isBulkSelected).replace(
          "{searchTerm}", payload.searchTerm);
    }
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async getScheduleReportNERPListAction({ commit }, payload) {
    let url = URI.REPORT_NERP_SCHEDULE_LIST_URL.replace("{currentPage}", payload.page.currentPage)
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const scheduleReport = await BaseService.getSchemePlanningClient().get(url);
    commit("setReports", scheduleReport.data);
    return scheduleReport.data;
  },
  async modifyScheduleNERPReportAction({ commit }, payload) {
    let url = URI.REPORT_SCHEDULE_NERP_LIST_MODIFY_URL;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async downloadReportNERPExcelAction({ commit }, payload) {
    const url = URI.REPORT_NERP_EXPORT_FILE_URL.replace("{reportID}", payload.reportId);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async getSchemeProgramData({ commit }, payload) {
    let url = URI.SCHEME_PROGRAM_ITEM_GRID_URL.replace("reportIds", payload.reportID)
      .replace("{currentPage}", payload.page.currentPage)
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const schemePrgGridItem =
      await BaseService.getSchemePlanningClient().get(url);
    return schemePrgGridItem.data;
  },
  async downloadSchemeProgramExport({ commit }, payload) {
    const url = URI.SCHEME_PROGRAM_DOWNLOAD_URL.replace("{reportID}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async getDirectSchemeListActionNERP({ commit }, payload) {
    let url = "";
    if (payload.isBulkSelected) {
      url = URI.REPORT_NERP_BULK_DIRECT_SCHEME_LIST.replace(
        "{isBulkSelected}", payload.isBulkSelected).replace(
          "{searchTerm}", payload?.searchTerm ? payload?.searchTerm : "")
        .replace("{currentPage}", payload.page.currentPage)
        .replace("{pageSize}", payload.page.pageSize)
        .replace("{value}", payload.sord.value)
        .replace("{sortOrder}", payload.sord.__sortOrder);
      delete payload.page;
      delete payload.sord;
      delete payload.isBulkSelected;
    }
    else {
      url = URI.REPORT_NERP_DIRECT_SCHEME_LIST.replace(
        "{isBulkSelected}", payload.isBulkSelected).replace(
          "{searchTerm}", payload?.searchTerm ? payload?.searchTerm : "");
    }
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async getIMEIAction({ commit }, payload) {
    let url = "";
    if (payload.imeis) {
      url = URI.REPORT_IMEI_LEDGER_LIST
    }
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    commit("setIMEIAction", response.data.data);
    return response.data;
  },
  async downloadImeiLedgerExcel({ commit }, payload) {
    let url = URI.REPORT_IMEI_LEDGER_LIST.replace(
      "{imeis}",
      payload.imeis
    ).replace(
      "{reportName}", payload?.name ? payload?.name : "");
    let response = {};
    response = await BaseService.getSchemePlanningClient().post(url, payload);
    return response.data;
  },
  async deleteImeiReportAction({ commit }, payload) {
    let url = URI.DELETE_IMEI_REPORT;
    const result = await BaseService.getSchemePlanningClient().post(
      url, payload);
    return result.data;
  },
  async storePayoutReportDataToRedirectNERPAction({commit}, payload) {
    commit("setStorePayoutReportDataToRedirectNERPAction", payload);
  }
};

export default action;
